const WhatsappIcon = () => {
  return (
    <>
        <div className="whatsapp-icon">
          <a
            href="https://wa.me/917018168269"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
          >
            <i className="fab fa-whatsapp"></i>
          </a>
        </div>


    </>
  )
}

export default WhatsappIcon